import React from 'react'
import WhyChooseUsImage from "../../../Assets/Images/imgWhyChooseIP2BPN.jpg"
import { Link } from 'react-router-dom'

const WhyChooseUs = () => {
    return (
        <>
            <div className='container my-5 '>
                <div className='row'>
                    <div className='col-md-6 col-sm-12 text-center' style={{ alignSelf: "center" }}>
                        <img src={WhyChooseUsImage} alt='whychooseus' style={{ width: "100%" }} />
                    </div>
                    <div className='col-md-6 col-sm-12 '>
                        <div className=''>
                            <h3 style={{ color: "#fea44c" }}>Insurance, Simplified</h3>
                            <h2>
                                Why Choose Us?
                            </h2>
                        </div>
                        <div className='mt-4'>
                            <h5>Discover how our cutting-edge Artificial Intelligence-driven technology can streamline your insurance journey. We offer a comprehensive range of insurance products tailored to meet your unique needs with precision and efficiency.</h5>
                        </div>
                        <div>
                            <h5 className='mt-4' ><strong>Assessing Your Needs</strong></h5>
                        </div>
                        <div className='mt-3'>
                            <h5>Unpredictable events and inadequate insurance coverage can lead to significant risks. Our expert team is here to analyse your specific insurance requirements and secure the right coverage at the best price with leading insurance providers in India. Contact us today to ensure you're fully protected.</h5>
                        </div>
                        <div className='mt-4'>
                            <h5><strong>Building Lasting Relationships</strong></h5>
                        </div>
                        <div className='mt-3'>
                            <h5>Your insurance needs are as unique as you are. Whether for personal or business purposes, we provide customized assessments and solutions to safeguard your valuable assets. Reach out to us for a tailored approach that keeps your interests at the forefront.</h5>
                        </div>
                        <div className='mt-4'>
                            <Link to={`${process.env.PUBLIC_URL}/contact`}>
                                <button className='why-choose-us-button'>Contact Us</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhyChooseUs